import React, { useState } from 'react'
import Card from './Card'
import { IDepartment, IEmployee, ISpace } from '@api'
import { get } from 'lodash'
import css from './seatableSpaceCard.module.scss'
import { isFinder, isMeetingRoom } from '@utils'
import { Dialog } from '@ui'
import { EmployeeDetailCard } from '../Card'

export const SpaceDetailCard = ({
  space,
  showAssetModal,
  showEmployees,
  showAvatar,
  showEmail,
  showAsset,
  showWpg,
  hideDept,
  smallText,
  avatarProps = {},
}: {
  space: ISpace
  showEmployees?: boolean
  showAssetModal?: boolean
  showAvatar?: boolean
  showEmail?: boolean
  showWpg?: boolean
  showAsset?: boolean
  hideDept?: boolean
  smallText?: string
  avatarProps?: any
}) => {
  const [showAssetsModal, setShowAssetsModal] = useState(false)
  const assets = (space.tags || []).map((t) => t.name).sort()
  const assetsList = assets.length ? assets.join(', ') : 'N/A'
  const deskType = isMeetingRoom(space.spaceType)
    ? 'Meeting Room'
    : space.usageType
    ? get(space, 'usageType.displayName', '')
    : 'Other'

  if (deskType === 'Other' && space.globalMapObject) {
    return <Card>{space.globalMapObject.name}</Card>
  }
  const {
    externalId,
    code,
    workplaceGroup,
    spaceAssignment: { department, team, employee, sharedEmployees },
  } = space
  const dept = getDepartmentInfo(department, team)
  const wpg = get(workplaceGroup, 'name', 'N/A')
  let empList: string[] = []

  if (employee) {
    empList = [employee.name]
  } else if (sharedEmployees && sharedEmployees.length) {
    empList = getEmployeesInfo(sharedEmployees)
  }

  return (
    <Card>
      <AssetsModal show={showAssetsModal} onClose={() => setShowAssetsModal(false)} list={assets} />
      <Card.Details>
        <Card.Title>
          <span className={css.title}>{deskType}</span>
          <div style={{ fontSize: 14 }}>{smallText}</div>
        </Card.Title>
        <Card.Row label="Space Id:" value={externalId} />
        {!hideDept && <Card.Row label="Department:" value={dept} />}
        {showWpg && <Card.Row label="Workplace group:" value={wpg} />}
        {showAsset && (
          <Card.Row
            label="Assets:"
            value={
              showAssetModal && assets.length > 1
                ? [
                    <div className={css.assetsLink} onClick={() => setShowAssetsModal(true)}>
                      LIST
                    </div>,
                  ]
                : assetsList
            }
          />
        )}
        {showEmployees && empList.length > 0 && (
          <Card.Row
            label="Employees:"
            value={[
              <div style={{ maxWidth: 192 }}>
                {empList.map((e) => (
                  <EmployeeDetailCard
                    showEmail={showEmail}
                    avatar={showAvatar}
                    name={e}
                    avatarProps={avatarProps}
                  />
                ))}
              </div>,
            ]}
          />
        )}
        {space.comment && <Card.Row label="Space Note:" value={space.comment} />}
      </Card.Details>
    </Card>
  )
}

export const getEmployeesInfo = (sharedEmployees: IEmployee[]) => {
  if (sharedEmployees.length > 4) {
    const employees = sharedEmployees
      .sort()
      .slice(0, 3)
      .map((i) => i.name)
    employees.push(`and +${sharedEmployees.length - 3} more`)
    return employees
  }

  if (sharedEmployees.length <= 4) {
    return sharedEmployees.sort().map((i) => i.name)
  }
  return []
}

export const getDepartmentInfo = (department: IDepartment | null, team: IDepartment | null) => {
  let departmentInfo: string[] | undefined = undefined
  if (department) {
    departmentInfo = [department.name]
  }
  if (team) {
    departmentInfo = departmentInfo ? [...departmentInfo, ' ' + team.name] : [team.name]
  }
  return departmentInfo?.join('') || 'N/A'
}

export function AssetsModal({
  show,
  onClose,
  list,
}: {
  show: boolean
  onClose: () => void
  list: string[]
}) {
  if (!list) return null

  return (
    <Dialog
      isOpen={show}
      onClose={onClose}
      isCloseButtonShown
      title="Space Assets"
      body={
        <>
          <div>
            <div className={css.assetsModalList}>
              {list.map((l) => (
                <div className={css.assetsModalItem} key={l}>
                  {l}
                </div>
              ))}
            </div>
          </div>
        </>
      }
    />
  )
}

export default SpaceDetailCard
